import { xValues } from "../constants/patternAcousticPerformances";

export default data => ({
  labels: xValues,
  datasets: [
    {
      label: "",
      fill: false,
      lineTension: 0.1,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "rgba(0, 0, 0, 1)",
      borderCapStyle: "butt",
      borderDashOffset: 0.0,
      borderJoinStyle: "miter",
      borderWidth: 2,
      pointBorderColor: "rgba(0, 0, 0, 1)",
      pointBackgroundColor: "rgba(0, 0, 0, 1)",
      pointBorderWidth: 2,
      pointHoverRadius: 3,
      pointHoverBackgroundColor: "rgba(0, 0, 0, 1)",
      pointHoverBorderColor: "rgba(0, 0, 0, 1)",
      pointHoverBorderWidth: 2,
      pointRadius: 3,
      pointHitRadius: 10,
      tooltips: {
        enabled: false
      },
      legend: {
        display: false
      },
      data: data
    }
  ]
});



// WEBPACK FOOTER //
// ./src/utils/getPatternAcousticPerfChartData.js